import React from 'react';
import {
  Box,
  Flex,
} from 'reflexbox';
import styled from 'styled-components';

const FooterText = styled.p`
  font-family: ${(props) => props.theme.font.family};
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: #c1c8cf;
`;

function Footer() {
  return (
    <>
      <Flex
        alignItems="center"
        pt={4}
      >
        <Box
          width={1}
          textAlign="center"
        >
          <FooterText>
            SpankChain &copy; All rights Reserved 2020
          </FooterText>
        </Box>
      </Flex>
    </>
  );
}

export default Footer;
